import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { ResultsContainer } from '../styles/FullScreenSearch.styles';
import FullScreenSearchOption from './FullScreenSearchOption';
import Separator from './Separator';
export const FullScreenSearchResults = ({
  allOptions,
  noMatchesOption,
  onSelectOption,
  preFillList,
  searchValue,
  renderOption,
  showOptionsWhenNullSearchValue,
  illustrationName,
  illustrationCaption,
  illustrationWidth,
  filteredOptions
}) => {
  const shouldShowZeroState = !showOptionsWhenNullSearchValue && !searchValue;

  if (shouldShowZeroState) {
    return /*#__PURE__*/_jsx(ResultsContainer, {
      className: "m-x-auto",
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          textAlign: 'center',
          fontSize: 15,
          marginTop: '2rem'
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-x-auto",
          style: {
            marginBottom: 8,
            maxWidth: 180,
            lineHeight: 1.2
          },
          children: illustrationCaption && /*#__PURE__*/_jsx(FormattedMessage, {
            message: illustrationCaption
          })
        }), illustrationName && /*#__PURE__*/_jsx(UIIllustration, {
          className: "m-top-3",
          name: illustrationName,
          width: illustrationWidth
        })]
      })
    });
  }

  return /*#__PURE__*/_jsx(ResultsContainer, {
    className: "m-x-auto",
    children: searchValue ? filteredOptions.map(option => /*#__PURE__*/_jsx(FullScreenSearchOption, {
      noMatchesOption: noMatchesOption,
      option: option,
      renderOption: renderOption,
      onSelectOption: onSelectOption
    }, option.value)) : /*#__PURE__*/_jsxs("div", {
      children: [preFillList && preFillList.length > 0 && /*#__PURE__*/_jsxs("div", {
        style: {
          marginBottom: '10px'
        },
        children: [preFillList.map(option => /*#__PURE__*/_jsx(FullScreenSearchOption, {
          noMatchesOption: noMatchesOption,
          option: option,
          renderOption: renderOption,
          onSelectOption: onSelectOption
        }, option.value)), /*#__PURE__*/_jsx(Separator, {})]
      }), allOptions.map(option => /*#__PURE__*/_jsx(FullScreenSearchOption, {
        noMatchesOption: noMatchesOption,
        option: option,
        renderOption: renderOption,
        onSelectOption: onSelectOption
      }, option.value))]
    })
  });
};